import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Typography from '../../../../../../components/Typography';

// Context
import { useDataSettingsContext } from '../../context';

// Styles
import viewsStyles from '../views.module.scss';
import Button from '../../../../../../components/button';

interface ViewChangePasswordSuccessProps {
  isCreatePassword?: boolean;
}

const ViewChangePasswordSuccess: React.FC<ViewChangePasswordSuccessProps> = ({ isCreatePassword }) => {
  const { t } = useTranslation();

  const { onClose } = useDataSettingsContext();

  return (
    <div className={viewsStyles.container}>
      <Typography variant="p">
        {t('profile.settings.data.change_password.success')}
      </Typography>

      <div className={viewsStyles.actions}>
        <Button
          type="primary"
          className={viewsStyles.actions_button}
          onClick={onClose}
        >
          {t('globals.okay')}
        </Button>
      </div>
    </div>
  );
};

export default ViewChangePasswordSuccess;
